
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "point",
  "use": "point-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"point\"><path d=\"M24.152.008V0c-.051 0-.101.003-.152.003-.05 0-.1-.003-.152-.003v.008C13.535.172 5.225 8.578 5.225 18.928 5.225 32.878 21.602 46.12 24 48c2.398-1.88 18.775-15.122 18.775-29.072 0-10.35-8.31-18.756-18.623-18.92z\" /></symbol>"
});
    sprite.add(symbol);

    export default class PointSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="point" {...this.props} />;
      }
    }
  